import { render, staticRenderFns } from "./SkuAlias.vue?vue&type=template&id=0031ad06&scoped=true&"
import script from "./SkuAlias.vue?vue&type=script&lang=js&"
export * from "./SkuAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031ad06",
  null
  
)

export default component.exports